//@flow
import _ from 'lodash';
import * as React from 'react';
import { connect } from 'react-redux';
import IconDelete from '../../images/icon_x_red.svg';
import FormTextArea from '../../components/inputs/FormTextArea';
import InputViewEdit from '../inputs/InputViewEdit';

type Props = {
  medicamento: any,
  removeItem: any,
  viewMode: Boolean,
};

class ReceituarioExamesOutros extends React.Component<Props, State> {
  newOptionCreator = (newOption: any) => {
    console.log('newOptionCreator');
    return { nome: newOption.label, hora: this.props.horario };
  };

  onNewOptionClick = (newOption: any) => {
    console.log('onNewOptionClick');
    console.log(newOption);
  };

  render() {
    const { entity, propName, index, viewMode } = this.props;

    return (
      <div className="form-row d-flex flex-row align-items-start med-prescrito">
        <label className="w-100 mb-2">
          <b>Exame</b>
        </label>
        <div className="col-12 col-lg d-flex align-items-center justify-content-center number">
          {viewMode ? index + 1 : 'E'}
        </div>
        <div className="col-12 col-lg-10 mb-2">
          <InputViewEdit
            component={FormTextArea}
            className={'textArea'}
            label=""
            id={`prescricao${index}`}
            onChange={this.props.onChange}
            viewMode={viewMode}
            viewClassName={'mt-2'}
            placeholder="Insira aqui a prescrição"
            required={true}
            value={_.get(entity, `${propName}.prescricao`)}
            name={`${propName}.prescricao`}
          />
        </div>
        {!viewMode && (
          <div className="col-12 col-lg d-flex justify-content-center btn-action p-0">
            <div
              className={`icon-delete d-flex align-items-center justify-content-center`}
              onClick={() => {
                this.props.removeItem();
              }}
            >
              <img src={IconDelete} alt="Deletar medicamento" />
            </div>
          </div>
        )}
        {/* <hr></hr> */}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  };
}

const mapDispatch = ({
  alert: { success, error, clear },
  load: { loading },
}) => ({
  success: (msg) => success(msg),
  loading: (load: boolean) => loading({ load }),
  error: (msg) => error(msg),
  clear: () => clear(),
});

export default connect(mapStateToProps, mapDispatch, null, {
  forwardRef: true,
})(ReceituarioExamesOutros);
